import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

// No longer importing TopReportedProjects

export default function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
        // Initialize GA if it hasn't been already.
        if (ReactGA.isInitialized) {
            // Send a pageview event to Google Analytics
            ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
        }
    }, [location]);

    // This component does not render anything to the screen
    return null;
}